import { VaultExportModel } from '../api/vault-api';
import { isAbleToSeeUIElement, VaultRoles } from './roles/client-roles';
import { Messages } from './message-constants';

export const formatBytes = (bytes?: number): string => {
  if (bytes == null) {
    return 'N/A';
  }
  if (bytes === 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  let value = bytes;

  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }

  return `${value.toFixed(2)} ${units[index]}`;
};

export const toCamelCase = (str?: string): string => {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getDeletePermissionForCorpus = (
  corpus: VaultExportModel['corpus']
) => {
  switch (corpus) {
    case 'MAIL':
      return VaultRoles.DeleteGmailVaultExport;
    case 'HANGOUTS_CHAT':
      return VaultRoles.DeleteChatVaultExport;
    case 'GEMINI':
      return VaultRoles.DeleteGeminiVaultExport;
    case 'CALENDAR':
      return VaultRoles.DeleteCalendarVaultExport;
    case 'DRIVE':
      return VaultRoles.DeleteDriveVaultExport;
    case 'GROUPS':
      return VaultRoles.DeleteGroupsVaultExport;
    default:
      return VaultRoles.DeleteVaultExports;
  }
};

export interface CanDeleteMatterResult {
  canDelete: boolean;
  tooltip: string;
}

export const getDeleteMatterPermissionState = (
  toolsRoles: string[]
): CanDeleteMatterResult => {
  const hasGlobalDelete = isAbleToSeeUIElement(
    toolsRoles,
    VaultRoles.DeleteVaultExports.value
  );

  const granularPermissions = [
    VaultRoles.DeleteGmailVaultExport,
    VaultRoles.DeleteChatVaultExport,
    VaultRoles.DeleteGeminiVaultExport,
    VaultRoles.DeleteCalendarVaultExport,
    VaultRoles.DeleteDriveVaultExport,
    VaultRoles.DeleteGroupsVaultExport,
  ];

  const missingGranular = granularPermissions.filter(
    (perm) => !isAbleToSeeUIElement(toolsRoles, perm.value)
  );

  const hasAllGranularDelete = missingGranular.length === 0;

  if (!hasGlobalDelete && !hasAllGranularDelete) {
    return {
      canDelete: false,
      tooltip: Messages.Errors.Permission.ActingMultiple([
        VaultRoles.DeleteVaultExports.name,
        'all granular delete permissions',
      ]),
    };
  }

  return {
    canDelete: true,
    tooltip: 'Delete',
  };
};
